import { render, staticRenderFns } from "./DispensaItem.vue?vue&type=template&id=15e2144b&"
import script from "./DispensaItem.vue?vue&type=script&lang=js&"
export * from "./DispensaItem.vue?vue&type=script&lang=js&"
import style0 from "./DispensaItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports